
import { Component, Vue, Watch } from 'vue-property-decorator';
import store from '@/store/index';
import { set, get } from '@/lib/service/storage';
import {
    isUndef,
    serverDateNow,
    dateParse,
    dateOffset,
    dateNow,
    dateFormat,
} from '@/lib/utils';
import QrcodePopup from '@/components/popup/qrcodePopup.vue';
import DistrictPicker from '@/features/district/districtPicker.vue';
import {
    ROUTE_NAME,
    datePopup,
} from '@/lib/constant';
import { Dialog } from 'vant';
import WechatPopup from '@/components/activity/wechatPopup.vue';


@Component({
    name: 'App',
    components: {
        QrcodePopup,
        DistrictPicker,
        [Dialog.Component.name]: Dialog.Component,
        WechatPopup,
    },
})
export default class App extends Vue {
    public topVisiable: boolean = false;
    public scroll: boolean = true;
    public show = false;
    public show1 = false;
    public show1Option = {
        link: '',
        image: '',
    };
    /** 跳转到某活动id */
    public activityId = '26';
    /** 请求提示数量 */
    public get requesting() {
        return store.state.util.requesting;
    }
    /** 错误提示数量 */
    public get errorCount() {
        return store.state.error.errorCount;
    }
    /** 错误信息 */
    public get errorInfo() {
        return store.state.error.errorInfo || {
            type: 'icon',
            icon: '&#xe621;',
            text: '发生了一些错误',
        };
    }
    /** 提示是否可见 */
    public get indicatorVisible() {
        return this.requesting + this.errorCount > 0;
    }
    /** 地址是否可见 */
    public get district() {
        return store.state.util.district;
    }
    /** 倒计时显示的弹窗图片内容 */
    public get countdownImage() {
        const key = dateFormat(dateNow());
        return datePopup[key];
    }

    public onDistrictUpdate(names: string, ids: string) {
        if (this.district.update) {
            this.district.update(names, ids);
        }
    }
    public onDistrictFinish() {
        if (this.district.finish) {
            this.district.finish();
        }
    }
    /**
     * 更换套餐
     */
    public onClickChangePackage() {
        this.show = false;
        this.$router.push({
            name: ROUTE_NAME.ACTIVITY_EQUIPMENT,
            params: {
                activityId: this.activityId,
            },
            query: {
                changePackage: '1',
            },
        });
    }
    public onClickChangePackage1() {
        this.show1 = false;
        if (this.show1Option.link) {
            location.href = this.show1Option.link;
        }
    }
    public scrollCallback() {
        if (!this.scroll) {
            return;
        }
        const scroll_top = window.pageYOffset || document.documentElement.scrollTop;
        if (scroll_top > window.innerHeight * 2.3) {
            this.topVisiable = true;
        } else {
            this.topVisiable = false;
        }
        return true;
    }
    /** 点击回到顶部 */
    public onClickGoTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }

    public async mounted() {
        store.commit('addScrollCallback', this.scrollCallback.bind(this));
        // const LocationShowName = get('SHOWPACKAGECHANGE')
        // if (isUndef(LocationShowName)) {
        //     setTimeout(async () => {
        //         const rdata = await store.dispatch('participation/getShowAlert');
        //         if (rdata.status === 0) {
        //             const show = rdata.data;
        //             this.show = show;
        //             if (show) {
        //                 set('SHOWPACKAGECHANGE', this.activityId);
        //             }
        //         }
        //     }, 1000);
        // }
        setTimeout(async () => {
            const rdata = await store.dispatch('user/getUserAlert');
            if (rdata.data && rdata.status === 0) {
                this.show1Option = rdata.data;
                this.show1 = true;
            }
        }, 1000);
    }
    public beforeDestroy() {
        this.scroll = false;
    }
}
